import {
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';
import { DATASET, SINK, SOURCE } from 'js/constants/notificationsTypes';

export const notificationTypes = {
  [RESOURCE_TYPE_DATA_SET]: DATASET,
  [RESOURCE_TYPE_SINK]: SINK,
  [RESOURCE_TYPE_SOURCE]: SOURCE,
};
